import React, {Component, forwardRef} from 'react';
import {scroller} from "react-scroll";
import $ from 'jquery';
import {AJAX, close_popup, show_popup} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import UploadPhoto from "./UploadPhoto";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
//import MaskedInput from "react-text-mask/dist/reactTextMask";
//import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import moment from "moment";
import ReactTooltip from "react-tooltip";
import DatePicker from "react-datepicker";

let max_birth_year = moment().subtract(23, 'years').format('YYYY'),
	max_birth_date = new Date(moment().subtract(23, 'years').valueOf()),
	min_birth_year = moment().subtract(73, 'years').format('YYYY'),
	min_birth_date = new Date(moment().subtract(73, 'years').valueOf()),
	min_license_expire_date = new Date(moment().add(5, 'days').valueOf()),
	min_license_expire_year = moment().add(5, 'days').format('YYYY'),
	max_license_expire_year = moment().add(60, 'years').format('YYYY'),
	max_license_expire_date = new Date(moment().add(60, 'years').valueOf());


const CustomInput = forwardRef(({ value, name, placeholder, onClick }, ref) => (
	<input
		className="form-control datepicker age driver_dob required"
		ref={ref}
		onClick={onClick}
		value={value}
		autoComplete="off"
		type="text"
		readOnly={true}
		style={{cursor: "default", backgroundColor: "#fff"}}
		name={name}
		id={name}
		placeholder={placeholder}
	/>
));
const range = (start, stop, step = 1) => Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step)
const birth_years = range(Number(min_birth_year), Number(max_birth_year) + 1, 1);
const license_years = range(Number(min_license_expire_year), Number(max_license_expire_year) + 1, 1);
const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December",];

class BookingDetailsPage extends Component {
	constructor(props) {
		super(props);
		this.handleUploadPhoto = this.handleUploadPhoto.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSwitch = this.onSwitch.bind(this);
		this.onRecalculate = this.onRecalculate.bind(this);
		this.onBlurHandler = this.onBlurHandler.bind(this);
		this.onChangeInput = this.onChangeInput.bind(this);

		this.state = {
			booking: [
				'additional_driver_fname',
				'additional_driver_lname',
				'additional_driver_email',
				'additional_driver_phone',
				'additional_driver_dob',
				'additional_driver_licenseno',
				'additional_driver_license_country',
				'additional_driver_license_expiry',
				'additional_driver_address',
				'additional_driver_city',
				'additional_driver_state',
				'additional_driver_postcode'
			],
			additional_drivers: {},
			driver_license_images: {},
			billing_details_show: false,
			reset_photo_fields: false,
			business_nameError: '',
			business_nameDirty: false,
			contact_nameError: '',
			contact_nameDirty: false,
			contact_emailError: '',
			contact_emailDirty: false,
			contact_phoneError: '',
			contact_phoneDirty: false,
			contact_addressError: '',
			contact_addressDirty: false,

			main_driver_fname: this.props.booking_form_data.booking.main_driver_fname !== undefined ? this.props.booking_form_data.booking.main_driver_fname : ( this.props.booking_form_data.booking.quote_firstname !== undefined ? this.props.booking_form_data.booking.quote_firstname : ''),
			main_driver_lname: this.props.booking_form_data.booking.main_driver_lname !== undefined ? this.props.booking_form_data.booking.main_driver_lname : ( this.props.booking_form_data.booking.quote_lastname !== undefined ? this.props.booking_form_data.booking.quote_lastname : ''),
			main_driver_email: this.props.booking_form_data.booking.main_driver_email !== undefined ? this.props.booking_form_data.booking.main_driver_email : (this.props.booking_form_data.booking.quote_email !== undefined ? this.props.booking_form_data.booking.quote_email : ( this.props.booking_form_data.booking.interstate_email !== undefined ? this.props.booking_form_data.booking.interstate_email : '')),
			main_driver_phone: this.props.booking_form_data.booking.main_driver_phone !== undefined ? this.props.booking_form_data.booking.main_driver_phone : (this.props.booking_form_data.booking.quote_phone !== undefined ? this.props.booking_form_data.booking.quote_phone : ( this.props.booking_form_data.booking.interstate_phone !== undefined ? this.props.booking_form_data.booking.interstate_phone : '')),
			main_driver_fnameError: this.props.booking_form_data.booking.main_driver_fname !== undefined ? '' : ( this.props.booking_form_data.booking.quote_firstname !== undefined ? '' : 'This field is required.'),
			main_driver_lnameError: this.props.booking_form_data.booking.main_driver_lname !== undefined ? '' : ( this.props.booking_form_data.booking.quote_lastname !== undefined ? '' : 'This field is required.'),
			main_driver_emailError: this.props.booking_form_data.booking.main_driver_email !== undefined ? '' : (this.props.booking_form_data.booking.quote_email !== undefined ? '' : ( this.props.booking_form_data.booking.interstate_email !== undefined ? '' : 'This field is required.')),
			main_driver_phoneError: this.props.booking_form_data.booking.main_driver_phone !== undefined ? '' : (this.props.booking_form_data.booking.quote_phone !== undefined ? '' : ( this.props.booking_form_data.booking.interstate_phone !== undefined ? '' : 'This field is required.')),
			main_driver_fnameDirty: false,
			main_driver_lnameDirty: false,
			main_driver_emailDirty: false,
			main_driver_phoneDirty: false,

			main_driver_dobError: 'This field is required.',
			main_driver_dobDirty: false,
			main_driver_licensenoError: 'This field is required.',
			main_driver_licensenoDirty: false,
			main_driver_license_countryError: 'This field is required.',
			main_driver_license_countryDirty: false,
			main_driver_license_expiryError: 'This field is required.',
			main_driver_license_expiryDirty: false,
			main_driver_addressError: 'This field is required.',
			main_driver_addressDirty: false,
			main_driver_cityError: 'This field is required.',
			main_driver_cityDirty: false,
			main_driver_stateError: 'This field is required.',
			main_driver_stateDirty: false,
			main_driver_postcodeError: 'This field is required.',
			main_driver_postcodeDirty: false,
			main_driver_licenseError: 'This field is required.',
			main_driver_licenseDirty: false,
			main_driver_backError: '',
			main_driver_backDirty: true,
			main_driver_selfieError: 'This field is required.',
			main_driver_selfieDirty: false,
			validate: false,
			main_driver_dob: '',
			main_driver_license_expiry: '',
			main_driver_license_countryInternational: false,
			main_driver_postcode: '',
			main_driver_license_eLicense:false
		};
	}

	componentDidMount() {
		if (this.props.scroll_to_element === 'id_drivers_div') {
			scroller.scrollTo(this.props.scroll_to_element, {
				duration: 800,
				smooth: true,
				offset: window.offset_scroll_value(),
			})
			this.props.handleSetSomeBlock('scroll_to_element', '');
		}

		let add_booking = this.state.booking;
		add_booking.push('driver_license', 'driver_back', 'driver_selfie');
		if (this.props.booking_form_data.booking.additional_drivers > 0) {
			Object.keys(add_booking).map((item) => {
				for (let i = 0; i < this.props.booking_form_data.booking.additional_drivers; i++) {
					this.setState({[ i + '_driver_license_eLicense']:false});
					if (add_booking[item] === 'driver_back') // not required
						this.setState({[i + '_' + add_booking[item] + 'Error']: '', [i + '_' + add_booking[item] + 'Dirty']: true});
					else
						this.setState({[i + '_' + add_booking[item] + 'Error']: 'This field is required.', [i + '_' + add_booking[item] + 'Dirty']: false});
				}
			});
			for (let i = 0; i < this.props.booking_form_data.booking.additional_drivers; i++) {
				this.setState({[i + '_additional_driver_license_countryInternational']: false, [i + '_additional_driver_license_country']: ''});
			}
		}
	}

	componentDidUpdate(previousProps, prevState) {
		if (this.props.reset_photo_fields && previousProps.reset_photo_fields !== this.props.reset_photo_fields) {
			this.setState({
				driver_license_images: {},
				main_driver_licenseError: 'This field is required.',
				main_driver_licenseDirty: false,
				main_driver_backError: '',
				main_driver_backDirty: true,
				main_driver_selfieError: 'This field is required.',
				main_driver_selfieDirty: false
			});

			let add_booking = [];
			if (this.props.booking_form_data.booking.additional_drivers > 0) {
				add_booking.push('driver_license', 'driver_back', 'driver_selfie');
				Object.keys(add_booking).map((item) => {
					for (let i = 0; i < this.props.booking_form_data.booking.additional_drivers; i++) {
						if (add_booking[item] === 'driver_back') // not required
							this.setState({[i + '_' + add_booking[item] + 'Error']: '', [i + '_' + add_booking[item] + 'Dirty']: true});
						else
							this.setState({[i + '_' + add_booking[item] + 'Error']: 'This field is required.', [i + '_' + add_booking[item] + 'Dirty']: false});
					}
				});
			}
		}

		if (prevState.main_driver_license_countryInternational !== this.state.main_driver_license_countryInternational) {
			this.setState({main_driver_stateError: 'This field is required.', main_driver_stateDirty: false});
			this.setState({main_driver_postcodeError: 'This field is required.', main_driver_postcodeDirty: false, main_driver_postcode: ''});
		}
		if (this.props.booking_form_data.booking.additional_drivers > 0) {
			for (let i = 0; i < this.props.booking_form_data.booking.additional_drivers; i++) {
				if (prevState[i + '_additional_driver_license_countryInternational'] !== this.state[i + '_additional_driver_license_countryInternational']) {
					this.setState({[i + '_additional_driver_stateError']: 'This field is required.', [i + '_additional_driver_stateDirty']: false});
					this.setState({[i + '_additional_driver_postcodeError']: 'This field is required.', [i + '_additional_driver_postcodeDirty']: false, [i + '_additional_driver_postcode']: ''});
				}
			}
		}

		const firstError = document.querySelector('.has-danger');
		if (firstError) {
			const target = firstError.querySelector('input, select, textarea, [tabindex]:not([tabindex="-1"])');
			if (target) {
				scroller.scrollTo(target.id, {
					duration: 800,
					smooth: true,
					offset: window.offset_scroll_value(),
				});
				target.focus({preventScroll: true});
			}
		}
	}

	onBlurHandler(e) {
		let name = e.target.name + 'Dirty';
		this.setState({[name]: true});
	}

	onChangeInput(e) {
		let nameError = e.target.name + 'Error';

		let emails_array = ['main_driver_email', 'contact_email'];
		let phone_array = ['main_driver_phone', 'contact_phone'];
		let dob_array = ['main_driver_dob'];
		let lic_exp_array = ['main_driver_license_expiry'];
		let post_array = ['main_driver_postcode'];

		if (this.props.booking_form_data.booking.additional_drivers > 0) {
			for (let i = 0; i < this.props.booking_form_data.booking.additional_drivers; i++) {
				emails_array.push(i + '_additional_driver_email');
				phone_array.push(i + '_additional_driver_phone');
				dob_array.push(i + '_additional_driver_dob');
				lic_exp_array.push(i + '_additional_driver_license_expiry');
				post_array.push(i + '_additional_driver_postcode');
			}
		}

		if (post_array.includes(e.target.name))
			this.setState({[e.target.name]: e.target.value});

		if (e.target.value.length > 0) {
			this.setState({[nameError]: ''});

			if (phone_array.includes(e.target.name)) {
				const re2 = /^(\+6\d{10}|0\d{9})$/;
				if (!re2.test(e.target.value)) {
					this.setState({[nameError]: 'Please enter a valid phone number.'});
				}
			}
			if (emails_array.includes(e.target.name)) {
				const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
				if (!re.test(String(e.target.value).toLowerCase()))
					this.setState({[nameError]: 'Please enter a valid email address.'});
			}
			if (dob_array.includes(e.target.name)) {
				let dob = Number(moment(e.target.value, "DD-MM-YYYY").format("YYYY"));
				if (dob > Number(max_birth_year) || dob < Number(min_birth_year))
					this.setState({[nameError]: 'Year of birth must be between '+ min_birth_year + ' and ' + max_birth_year + ' years.'});
			}
			if (lic_exp_array.includes(e.target.name)) {
				let lic_exp = moment(e.target.value, "DD-MM-YYYY");
				if (moment().add(5, 'days').diff(lic_exp,'days') > 0)
					this.setState({[nameError]: 'Date must be after '+ moment().add(5, 'days').format("DD-MM-YYYY") + '.'});
			}
			if (!this.state.main_driver_license_countryInternational && e.target.name === 'main_driver_postcode') {
				if (e.target.value.replace(/\D/g, '') !== e.target.value || e.target.value.length !== 4)
					this.setState({[nameError]: 'Post Code should only be 4 numbers.'});
			}
			if (this.props.booking_form_data.booking.additional_drivers > 0) {
				for (let i = 0; i < this.props.booking_form_data.booking.additional_drivers; i++) {
					if (!this.state[i + '_additional_driver_license_countryInternational'] && e.target.name === i + '_additional_driver_postcode') {
						if (e.target.value.replace(/\D/g, '') !== e.target.value || e.target.value.length !== 4)
							this.setState({[nameError]: 'Post Code should only be 4 numbers.'});
					}
				}
			}
		}
		else {
			this.setState({[nameError]: 'This field is required.'});
		}
	}

	onSwitch() {
		this.setState((prevState, props) => {
			let toSet = {billing_details_show: !prevState.billing_details_show};

			if (!prevState.billing_details_show) {
				toSet.business_nameError = toSet.contact_nameError = toSet.contact_emailError = toSet.contact_phoneError = toSet.contact_addressError = 'This field is required.';
			}
			else {
				toSet.business_nameError = toSet.contact_nameError = toSet.contact_emailError = toSet.contact_phoneError = toSet.contact_addressError = '';
				toSet.business_nameDirty = toSet.contact_nameDirty = toSet.contact_emailDirty = toSet.contact_phoneDirty = toSet.contact_addressDirty = false;
			}

			return toSet;
		});

	}

	handleUploadPhoto(photo_key, url = '', dirty = false, e_license = false) {
		if (url.length > 0 ) {
			let name = photo_key + 'Error';
			let images = this.state.driver_license_images;

			images[photo_key] = url;

			this.setState({driver_license_images: images, [name]: ''});
		}
		if (dirty) {
			let name = photo_key + 'Dirty';
			this.setState({[name]: dirty});
		}
		let el_name = photo_key + '_eLicense';
		if (e_license) {
			this.setState({[el_name]:true});
		}
		else {
			this.setState({[el_name]:false});
		}
	}

	onChange(e) {
		let value = e.target.value;
		let name = e.target.name;
		let recalculateInternational = false;

		if (value.length > 0) {
			this.setState({[name + 'Error']: ''});
			if (e.target.value === 'International')
				this.setState({[name + 'International']: true});
			else
				this.setState({[name + 'International']: false});
		}
		else {
			this.setState({[name + 'Error']: 'This field is required.', [name + 'International']: false});
		}

		let license_country_array = ['main_driver_license_country'];
		if (this.props.booking_form_data.booking.additional_drivers > 0) {
			for (let i = 0; i < this.props.booking_form_data.booking.additional_drivers; i++) {
				license_country_array.push(i + '_additional_driver_license_country');
			}
		}
		// check all driver license country on Interstate
		Object.keys(license_country_array).map((k) => {
			if ($(e.target).closest('.drivers').find('[name='+license_country_array[k]+']')[0].value.trim() === 'International')
				recalculateInternational = true;
		});

		if (recalculateInternational) {
			let content =
				<div className="row error-booking-popup">
					<div className="col-12 text-center">
						<div className="row m-3">
							<div className="col-12 text-center gray">
								You have inputted an international driver's license.
								<br/>
								The required pre-authorization charge involving international driver's licenses increases from $200 to $500.
								<br/>
								Please select Go NEXT to continue with the transaction or go BACK to update the information
							</div>
						</div>
						<div className="row mb-3">
							<div className="col-12 text-center">
								<button type="button" className="btn btn-green-border" onClick={close_popup}>Back</button>&nbsp;
								<button type="button" className="btn btn-green" onClick={() => this.onRecalculate('International')}>Confirm</button>
							</div>
						</div>
					</div>
				</div>;
			show_popup(content, {auto_close: false});
		}
		else {
			this.onRecalculate(value);
		}
	}

	onRecalculate(value) {
		let booking_form_data = this.props.booking_form_data;
		let params = {};
		let t = this;

		params.action = 'api/booking/get-total';
		params.signature_json = this.props.booking_form_data.signature_json;
		params.signature_png = this.props.booking_form_data.signature_png;
		params.vehicle_name = this.props.booking_form_data.vehicle_name;

		booking_form_data.booking['main_driver_license_country'] = value;
		if (this.state.billing_details_show)
			booking_form_data.booking['billing_details_different'] = 1;

		Object.keys(booking_form_data.booking).map((k) => {
			params['booking['+k+']'] = booking_form_data.booking[k];
		});

		if (this.props.booking_form_data.booking.hire == 'local') {
			params['booking[pickup_location]'] = this.props.booking_form_data.booking.pickuplocationid;
			params['booking[return_location]'] = this.props.booking_form_data.booking.dropofflocationid;
		}

		this.props.handleSetBookingDetails(false, booking_form_data.booking, this.state.driver_license_images, this.state.additional_drivers);

//		console.log('params', params, this.props.booking_form_data);

		AJAX(bf_ajax_url, 'POST', params, {
			response_json: true,
			func_waiting: function () {
			},
			func_callback: function (resp) {

				t.props.handleSetBookingSummary(true, false, false, false, false, false, resp);
				close_popup();

				if (t.props.payment_show) {
					params.action = 'api/booking/get_prices';
					params.submit = t.props.booking_form_data.submit;
					params.donation_count = t.props.booking_form_data.donation_count;

//					console.log('params', params);

					AJAX(bf_ajax_url, 'POST', params, {
						response_json: true,
						func_waiting: function () {
						},
						func_callback: function (resp) {

							if(resp.success && resp.data){
								t.props.handleSetShowData({total_charges: resp.data.total_charges, pre_authorization: resp.data.pre_authorization, total_all: resp.data.total_all});
							}
							else {
								showPopupWithGoBack('Session invalid, please try again');
							}

						},
						func_error: function (resp) {
							showPopupWithGoBack(resp.message);
						}
					});
				}
			},
			func_error: function (resp) {
				showPopupWithGoBack(resp.message);
			}
		});
	}

	onClick(e) {
		let booking = this.state.booking;
		let additional_drivers = {};
		let booking_form_data = this.props.booking_form_data;
		let fields = this.props.booking_field_list.booking_details;
		let btn = e.target;
		let form_inputs = $(btn).closest('.drivers');

		let validate = true;
		let toSet = {};

		if (this.state.billing_details_show)
			booking_form_data.booking['billing_details_different'] = 1;

		Object.keys(fields).map((item) => {
			let el = form_inputs.find('[name='+fields[item]+']');
			if (el.length) {
				booking_form_data.booking[fields[item]] = el[0].value.trim();
			}
			if (this.state[fields[item] + 'Error'] !== '') {
				toSet[fields[item] + 'Dirty'] = true;
				validate = false;
			}
		});

		if (this.state.main_driver_licenseError !== '') {
			toSet.main_driver_licenseDirty = true;
			validate = false;
		}
		if (this.state.main_driver_selfieError !== '') {
			toSet.main_driver_selfieDirty = true;
			validate = false;
		}

		if (this.props.booking_form_data.booking.additional_drivers > 0) {
			Object.keys(booking).map((item) => {
				let driver_item = {};
				for (let i = 0; i < this.props.booking_form_data.booking.additional_drivers; i++) {
					let el = form_inputs.find('[name=' + i + '_' + booking[item] + ']');
					if (el.length) {
						driver_item[i] = el[0].value.trim();
					}
					if (this.state[i + '_' + booking[item] + 'Error'] !== '') {
						toSet[i + '_' + booking[item] + 'Dirty'] = true;
						validate = false;
					}
				}
				additional_drivers[booking[item]] = driver_item;

				for (let i = 0; i < this.props.booking_form_data.booking.additional_drivers; i++) {
					if (this.state[i + '_driver_licenseError'] !== '') {
						toSet[i + '_driver_licenseDirty'] = true;
						validate = false;
					}
					if (this.state[i + '_driver_selfieError'] !== '') {
						toSet[i + '_driver_selfieDirty'] = true;
						validate = false;
					}
				}
			});
		}

		toSet.validate = validate;
		this.setState(toSet);

		if (validate) {
			this.setState({additional_drivers: additional_drivers});
			this.props.handleSetBookingDetails(true, booking_form_data.booking, this.state.driver_license_images, additional_drivers);
			this.props.handleSetSomeBlock('scroll_to_element', 'id_donate_div');
		}
		else {
			const firstError = document.querySelector('.has-danger');
			if (firstError) {
				const target = firstError.querySelector('input, select, textarea, [tabindex]:not([tabindex="-1"])');
				if (target) {
					scroller.scrollTo(target.id, {
						duration: 800,
						smooth: true,
						offset: window.offset_scroll_value(),
					});
					target.focus({preventScroll: true});
				}
			}
		}
	}

	setDate(name, date) {
		this.setState({[name]: date});

		let nameError = name + 'Error';
		if (date !== '') {
			this.setState({[nameError]: ''});

			let dob_array = ['main_driver_dob'];
			let lic_exp_array = ['main_driver_license_expiry'];

			if (this.props.booking_form_data.booking.additional_drivers > 0) {
				for (let i = 0; i < this.props.booking_form_data.booking.additional_drivers; i++) {
					dob_array.push(i + '_additional_driver_dob');
					lic_exp_array.push(i + '_additional_driver_license_expiry');
				}
			}

			if (dob_array.includes(name)) {
				let dob = Number(moment(date, "DD-MM-YYYY").format("YYYY"));
				if (dob > Number(max_birth_year) || dob < Number(min_birth_year))
					this.setState({[nameError]: 'Year of birth must be between '+ min_birth_year + ' and ' + max_birth_year + ' years.'});
			}
			if (lic_exp_array.includes(name)) {
				let lic_exp = moment(date, "DD-MM-YYYY");
				if (moment().add(5, 'days').diff(lic_exp,'days') > 0)
					this.setState({[nameError]: 'Date must be after '+ moment().add(5, 'days').format("DD-MM-YYYY") + '.'});
			}
		}
		else {
			this.setState({[nameError]: 'This field is required.'});
		}
	}

	render() {
		const drivers = [];
		for (let i = 0; i < this.props.booking_form_data.booking.additional_drivers; i++)
			drivers.push(i);

		const license_country_list = [
			'New South Wales',
			'Victoria',
			'Queensland',
			'Tasmania',
			'Northern Territories',
			'Western Australia',
			'South Australia',
			'Australian Capital Territory',
			'International'
		];

		const state_country_list = [
			'New South Wales',
			'Victoria',
			'Queensland',
			'Tasmania',
			'Northern Territories',
			'Western Australia',
			'South Australia',
			'Australian Capital Territory'
		];

		let license_text = "Go With The Gecko collects a driver's license image to verify driver information against the submitted data in the booking request, as well as confirming later against the submitted before and after photos during the vehicle hire period. Your license image should be of the license only, with as little obstruction of the driver's license as possible. An example of a suitable image quality is provided here… <br/><br/><img src='../../wp-content/plugins/booking-form/images/license.png' alt='Upload Driver’s License' className='aligncenter'/>";
		let back_text = "Go With The Gecko collects a driver's license image to verify driver information against the submitted data in the booking request, as well as confirming later against the submitted before and after photos during the vehicle hire period. Your license image should be of the license only, with as little obstruction of the driver's license as possible. An example of a suitable image quality is provided here… <br/><br/><img src='../../wp-content/plugins/booking-form/images/back.jpg' alt='Upload Back of Driver’s License' className='aligncenter'/>";
		let selfie_text = "Go With The Gecko collects a selfie image to verify the driver against the submitted license with the booking request, as well as confirming later against hirer photos submitted during the vehicle hire period. Your selfie should contain you holding the license, with as little obstruction of the driver's license as possible. An example of a suitable image quality is provided here…<br/><br/><img src='../../wp-content/plugins/booking-form/images/selfie.png' alt='Upload Selfie While Holding Driver’s License' className='aligncenter'/>";

		return (<>
			<RedirectOnlyHome />

			<div id={'id_drivers_div'} className={'col drivers'}>
				<h2 className="fs-title">Booking Details</h2>
				<h3 className="fs-subtitle">Hirer Details</h3>
				<div className="row">
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.main_driver_fnameDirty && this.state.main_driver_fnameError) && ' has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label htmlFor="main_driver_fname">First Name</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   type="text" id="main_driver_fname"
							   name="main_driver_fname"
							   defaultValue={this.state.main_driver_fname}
							   placeholder={"First Name *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
						/>
						{
							(this.state.main_driver_fnameDirty && this.state.main_driver_fnameError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_fnameError}</small>
						}
					</div>
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.main_driver_lnameDirty && this.state.main_driver_lnameError) && ' has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label htmlFor="main_driver_lname">Last Name</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   type="text"
							   id="main_driver_lname"
							   name="main_driver_lname"
							   defaultValue={this.state.main_driver_lname}
							   placeholder={"Last Name *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
						/>
						{
							(this.state.main_driver_lnameDirty && this.state.main_driver_lnameError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_lnameError}</small>
						}
					</div>
					<div className={'form-group col-md-4 fake-placeholder '+((this.state.main_driver_emailDirty && this.state.main_driver_emailError) && ' has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label htmlFor="main_driver_email">Email</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   type="email"
							   id="main_driver_email"
							   name="main_driver_email"
							   defaultValue={this.state.main_driver_email}
							   placeholder={"Email *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
						/>
						{
							(this.state.main_driver_emailDirty && this.state.main_driver_emailError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_emailError}</small>
						}
					</div>
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.main_driver_phoneDirty && this.state.main_driver_phoneError) && ' has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label htmlFor="main_driver_phone">Phone</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   type="text"
							   id="main_driver_phone"
							   name="main_driver_phone"
							   defaultValue={this.state.main_driver_phone}
							   placeholder={"Phone *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
						/>
						{
							(this.state.main_driver_phoneDirty && this.state.main_driver_phoneError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_phoneError}</small>
						}
					</div>
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.main_driver_dobDirty && this.state.main_driver_dobError) && ' has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>Date of birth</label>
							<span className="star">*</span>
						</div>
						<DatePicker
							renderCustomHeader={({
													 date,
													 changeYear,
													 changeMonth,
													 decreaseMonth,
													 increaseMonth,
													 prevMonthButtonDisabled,
													 nextMonthButtonDisabled,
												 }) => (
								<div style={{margin: 10, display: "flex", justifyContent: "center"}}>
									<button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{"<"}</button>
									<select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(value)}>
										{birth_years.map((option) => (
											<option key={option} value={option}>
												{option}
											</option>
										))}
									</select>

									<select value={months[(date.getMonth())]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
										{months.map((option) => (
											<option key={option} value={option}>
												{option}
											</option>
										))}
									</select>

									<button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{">"}</button>
								</div>
							)}
							customInput={<CustomInput />}
							onChange={(date) => this.setDate("main_driver_dob", date)}
							selected={this.state.main_driver_dob}
							dateFormat="dd-MM-yyyy"
							minDate={min_birth_date}
							maxDate={max_birth_date}
							id={"main_driver_dob"}
							name={"main_driver_dob"}
							placeholderText={"Date of birth *"}
							startDate={min_birth_date}
							onCalendarOpen={() => {this.setState({main_driver_dobDirty: true});}}
						/>
						{/*<MaskedInput
							mask={[ /[0-3]/, /\d/,'-', /[0-1]/, /\d/,'-', /\d/, /\d/, /\d/, /\d/]}
							className="form-control datepicker age driver_dob required"
							guide={true}
							name="main_driver_dob"
							pipe={autoCorrectedDatePipe_birth}
							keepCharPositions={true}
							placeholder={"Date of birth *"}
							onChange={this.onChangeInput}
							onBlur={this.onBlurHandler}
						/>*/}
						{
							(this.state.main_driver_dobDirty && this.state.main_driver_dobError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_dobError}</small>
						}
					</div>
				</div>

				<div className="row">
					<div className="form-group col-md-12">
						<div className="form-check">
							<input className="form-check-input" type="checkbox" id="billing_details_different" value="1"
								   name="billing_details_different" onClick={this.onSwitch}/>
							<label className="form-check-label" htmlFor="billing_details_different">
									<strong>Is Billing Details Different From Hirer Details?</strong>
							</label>
						</div>
					</div>
				</div>
				{
					this.state.billing_details_show &&
						<>
						<div className="row" style={{display: "flex"}}>
							<div  className={'form-group col-md-2 fake-placeholder '+((this.state.business_nameDirty && this.state.business_nameError) && ' has-danger')}>
								<div className="placeholder" style={{display: "none"}}>
									<label htmlFor="business_name">Business Name</label>
									<span className="star"> *</span>
								</div>
								<input className="form-control required"
									   type="text"
									   id="business_name"
									   name="business_name"
									   id="business_name"
									   placeholder={"Business Name *"}
									   onChange={this.onChangeInput}
									   onBlur={this.onBlurHandler}
								/>
								{
									(this.state.business_nameDirty && this.state.business_nameError) &&
									<small className="form-control-feedback d-block">{this.state.business_nameError}</small>
								}
							</div>
							<div className={'form-group col-md-2 fake-placeholder '+((this.state.contact_nameDirty && this.state.contact_nameError) && ' has-danger')}>
								<div className="placeholder" style={{display: "none"}}>
									<label htmlFor="contact_name">Contact Name</label>
									<span className="star"> *</span>
								</div>
								<input className="form-control required"
									   type="text"
									   id="contact_name"
									   name="contact_name"
									   placeholder={"Contact Name *"}
									   onChange={this.onChangeInput}
									   onBlur={this.onBlurHandler}
								/>
								{
									(this.state.contact_nameDirty && this.state.contact_nameError) &&
									<small className="form-control-feedback d-block">{this.state.contact_nameError}</small>
								}
							</div>
							<div className={'form-group col-md-4 fake-placeholder '+((this.state.contact_emailDirty && this.state.contact_emailError) && ' has-danger')}>
								<div className="placeholder" style={{display: "none"}}>
									<label>Email</label>
									<span className="star"> *</span>
								</div>
								<input className="form-control required"
									   type="email"
									   id="contact_email"
									   name="contact_email"
									   placeholder={"Email *"}
									   onChange={this.onChangeInput}
									   onBlur={this.onBlurHandler}
								/>
								{
									(this.state.contact_emailDirty && this.state.contact_emailError) &&
									<small className="form-control-feedback d-block">{this.state.contact_emailError}</small>
								}
							</div>
							<div className={'form-group col-md-2 fake-placeholder '+((this.state.contact_phoneDirty && this.state.contact_phoneError) && ' has-danger')}>
								<div className="placeholder" style={{display: "none"}}>
									<label>Phone</label>
									<span className="star"> *</span>
								</div>
								<input className="form-control required"
									   type="text"
									   id="contact_phone"
									   name="contact_phone"
									   placeholder={"Phone *"}
									   onChange={this.onChangeInput}
									   onBlur={this.onBlurHandler}
								/>
								{
									(this.state.contact_phoneDirty && this.state.contact_phoneError) &&
									<small className="form-control-feedback d-block">{this.state.contact_phoneError}</small>
								}
							</div>
						</div>
						<div className="row" style={{display: "flex"}}>
							<div className={'form-group col-md-4 fake-placeholder '+((this.state.contact_addressDirty && this.state.contact_addressError) && ' has-danger')}>
								<div className="placeholder" style={{display: "none"}}>
									<label>Address</label>
									<span className="star"> *</span>
								</div>
								<input className="form-control required"
									   type="text"
									   name="contact_address"
									   id="contact_address"
									   placeholder={"Address *"}
									   onChange={this.onChangeInput}
									   onBlur={this.onBlurHandler}
								/>
								{
									(this.state.contact_addressDirty && this.state.contact_addressError) &&
									<small className="form-control-feedback d-block">{this.state.contact_addressError}</small>
								}
							</div>
						</div>
					</>
				}

				<h3 className="fs-subtitle">Additional Details</h3>

				<div className="row">
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.main_driver_licensenoDirty && this.state.main_driver_licensenoError) && ' has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>License Number</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   autoComplete="off" type="text"
							   name="main_driver_licenseno"
							   id="main_driver_licenseno"
							   placeholder={"License Number *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
						/>
						{
							(this.state.main_driver_licensenoDirty && this.state.main_driver_licensenoError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_licensenoError}</small>
						}
					</div>
					<div className={'form-group col-md-3 '+((this.state.main_driver_license_countryDirty && this.state.main_driver_license_countryError) && ' has-danger')}>
						<select name="main_driver_license_country"
								id="main_driver_license_country"
								className="form-control"
								onChange={this.onChange}
								onBlur={this.onBlurHandler}>
							<option value="" >Select an Issuing Authority *</option>
							{
								license_country_list.map((val) => <option key={val} value={val}>{val}</option>)
							}
						</select>
						{
							(this.state.main_driver_license_countryDirty && this.state.main_driver_license_countryError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_license_countryError}</small>
						}
					</div>
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.main_driver_license_expiryDirty && this.state.main_driver_license_expiryError) && ' has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>License Expiry</label>
							<span className="star"> *</span>
						</div>
						<DatePicker
							renderCustomHeader={({
													 date,
													 changeYear,
													 changeMonth,
													 decreaseMonth,
													 increaseMonth,
													 prevMonthButtonDisabled,
													 nextMonthButtonDisabled,
												 }) => (
								<div style={{margin: 10, display: "flex", justifyContent: "center"}}>
									<button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{"<"}</button>
									<select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(value)}>
										{license_years.map((option) => (
											<option key={option} value={option}>
												{option}
											</option>
										))}
									</select>

									<select value={months[(date.getMonth())]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
										{months.map((option) => (
											<option key={option} value={option}>
												{option}
											</option>
										))}
									</select>

									<button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{">"}</button>
								</div>
							)}
							customInput={<CustomInput />}
							onChange={(date) => this.setDate("main_driver_license_expiry", date)}
							selected={this.state.main_driver_license_expiry}
							dateFormat="dd-MM-yyyy"
							minDate={min_license_expire_date}
							maxDate={max_license_expire_date}
							name={"main_driver_license_expiry"}
							placeholderText={"License Expiry *"}
							startDate={min_license_expire_date}
							onCalendarOpen={() => {this.setState({main_driver_license_expiryDirty: true});}}
						/>

						{
							(this.state.main_driver_license_expiryDirty && this.state.main_driver_license_expiryError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_license_expiryError}</small>
						}
					</div>
				</div>

				<div className="row">
					<div className={'form-group col-md-4 fake-placeholder '+((this.state.main_driver_licenseDirty && this.state.main_driver_licenseError) && ' has-danger')}>
						<div id="main_driver_license_div" className="tooltip-info-div">
							<UploadPhoto
								photo_key={'main_driver_license'}
								photo_type={'license'}
								dirty={this.state.main_driver_licenseDirty}
								error={this.state.main_driver_licenseError}
								handleUploadPhoto={this.handleUploadPhoto}
								reset_photo_fields={this.props.reset_photo_fields}
								handleSetSomeBlock={this.props.handleSetSomeBlock}
							/>
						</div>
						<i className="tooltip-info" data-tip data-for="react_tooltip_license">&nbsp;</i>
						<ReactTooltip
							id="react_tooltip_license"
							place="left"
							effect="solid"
							multiline={true}
							className={'react_tooltip'}
							backgroundColor={'black'}
							html={true}
							scrollHide={true}
							isCapture={true}>
							{license_text}
						</ReactTooltip>
					</div>
					{ !this.state.main_driver_license_eLicense &&
						<div className={'form-group col-md-4 fake-placeholder '+((this.state.main_driver_backDirty && this.state.main_driver_backError) && ' has-danger')}>
						<div id="main_driver_back_div" className="tooltip-info-div">
							<UploadPhoto
								photo_key={'main_driver_back'}
								photo_type={'back'}
								dirty={this.state.main_driver_backDirty}
								error={this.state.main_driver_backError}
								handleUploadPhoto={this.handleUploadPhoto}
								reset_photo_fields={this.props.reset_photo_fields}
								handleSetSomeBlock={this.props.handleSetSomeBlock}
							/>
						</div>
						<i className="tooltip-info" data-tip data-for="react_tooltip_back">&nbsp;</i>
						<ReactTooltip
							id="react_tooltip_back"
							place="left"
							effect="solid"
							multiline={true}
							className={'react_tooltip'}
							backgroundColor={'black'}
							html={true}
							scrollHide={true}
							isCapture={true}>
							{back_text}
						</ReactTooltip>
					</div>
					}
					<div className={'form-group col-md-4 fake-placeholder '+((this.state.main_driver_selfieDirty && this.state.main_driver_selfieError) && ' has-danger')}>
						<div id="main_driver_selfie_div" className="tooltip-info-div">
							<UploadPhoto
								photo_key={'main_driver_selfie'}
								photo_type={'selfie'}
								dirty={this.state.main_driver_selfieDirty}
								error={this.state.main_driver_selfieError}
								handleUploadPhoto={this.handleUploadPhoto}
								reset_photo_fields={this.props.reset_photo_fields}
								handleSetSomeBlock={this.props.handleSetSomeBlock}
							/>
						</div>
						<i className="tooltip-info" data-tip data-for="react_tooltip_selfie">&nbsp;</i>
						<ReactTooltip
							id="react_tooltip_selfie"
							place="left"
							effect="solid"
							multiline={true}
							className={'react_tooltip'}
							backgroundColor={'black'}
							html={true}
							scrollHide={true}
							isCapture={true}>
							{selfie_text}
						</ReactTooltip>
					</div>
				</div>

				<div className="row">
					<div className={'form-group col-md-4 fake-placeholder '+((this.state.main_driver_addressDirty && this.state.main_driver_addressError) && ' has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>Address</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   type="text"
							   name="main_driver_address"
							   placeholder={"Address *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
						/>
						{
							(this.state.main_driver_addressDirty && this.state.main_driver_addressError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_addressError}</small>
						}
					</div>
					<div className={'form-group col-md-3 fake-placeholder '+((this.state.main_driver_cityDirty && this.state.main_driver_cityError) && ' has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>City</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   type="text"
							   name="main_driver_city"
							   id="main_driver_city"
							   placeholder={"City *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
						/>
						{
							(this.state.main_driver_cityDirty && this.state.main_driver_cityError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_cityError}</small>
						}
					</div>
					<div className={'form-group col-md-3 fake-placeholder '+((this.state.main_driver_stateDirty && this.state.main_driver_stateError) && ' has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>State</label>
							<span className="star"> *</span>
						</div>
						{
							(this.state.main_driver_license_countryInternational) ?
								<input className="form-control required"
									   type="text"
									   name="main_driver_state"
									   id="main_driver_state"
									   placeholder={"State *"}
									   onChange={this.onChangeInput}
									   onBlur={this.onBlurHandler}
								/>
							:
								<select name="main_driver_state"
										className="form-control"
										onChange={this.onChangeInput}
										onBlur={this.onBlurHandler}>
									<option value="" >Select a State *</option>
									{
										state_country_list.map((val) => <option key={val} value={val}>{val}</option>)
									}
								</select>
						}
						{
							(this.state.main_driver_stateDirty && this.state.main_driver_stateError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_stateError}</small>
						}
					</div>
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.main_driver_postcodeDirty && this.state.main_driver_postcodeError) && ' has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>Postcode</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   type="text"
							   name="main_driver_postcode"
							   placeholder={"Postcode *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
							   value={this.state.main_driver_postcode}
						/>
						{
							(this.state.main_driver_postcodeDirty && this.state.main_driver_postcodeError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_postcodeError}</small>
						}
					</div>
				</div>

				{
					this.props.booking_form_data.booking.additional_drivers > 0 &&
						Object.keys(drivers).map((v, k) => {
							return(
								<div className="additional_drivers" key={drivers[v]}>
									<div className="additional">
										<h2>Additional Driver {drivers[v]+1}</h2>
										<div className="row">
											<div className={'form-group col-md-2 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_fnameDirty'] && this.state[drivers[v]+'_additional_driver_fnameError']) && ' has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>First Name</label>
													<span className="star"> *</span>
												</div>
												<input className="form-control required"
													   type="text"
													   name={(drivers[v])+'_additional_driver_fname'}
													   id={(drivers[v])+'_additional_driver_fname'}
													   placeholder={"First Name *"}
													   onChange={this.onChangeInput}
													   onBlur={this.onBlurHandler}
												/>
												{
													(this.state[drivers[v]+'_additional_driver_fnameDirty'] && this.state[drivers[v]+'_additional_driver_fnameError']) &&
													<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_fnameError']}</small>
												}
											</div>
											<div className={'form-group col-md-2 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_lnameDirty'] && this.state[drivers[v]+'_additional_driver_lnameError']) && ' has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>Last Name</label>
													<span className="star"> *</span>
												</div>
												<input className="form-control required"
													   type="text"
													   name={(drivers[v]) +'_additional_driver_lname'}
													   id={(drivers[v]) +'_additional_driver_lname'}
													   placeholder={"Last Name *"}
													   onChange={this.onChangeInput}
													   onBlur={this.onBlurHandler}
												/>
												{
													(this.state[drivers[v]+'_additional_driver_lnameDirty'] && this.state[drivers[v]+'_additional_driver_lnameError']) &&
													<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_lnameError']}</small>
												}
											</div>
											<div className={'form-group col-md-4 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_emailDirty'] && this.state[drivers[v]+'_additional_driver_emailError']) && ' has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>Email</label>
													<span className="star"> *</span>
												</div>
												<input className="form-control required"
													   type="email"
													   name={(drivers[v])+'_additional_driver_email'}
													   placeholder={"Email *"}
													   onChange={this.onChangeInput}
													   onBlur={this.onBlurHandler}
												/>
												{
													(this.state[drivers[v]+'_additional_driver_emailDirty'] && this.state[drivers[v]+'_additional_driver_emailError']) &&
													<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_emailError']}</small>
												}
											</div>
											<div className={'form-group col-md-2 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_phoneDirty'] && this.state[drivers[v]+'_additional_driver_phoneError']) && ' has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>Phone</label>
													<span className="star"> *</span>
												</div>
												<input className="form-control required"
													   type="text"
													   name={(drivers[v])+'_additional_driver_phone'}
													   id={(drivers[v])+'_additional_driver_phone'}
													   placeholder={"Phone *"}
													   onChange={this.onChangeInput}
													   onBlur={this.onBlurHandler}
												/>
												{
													(this.state[drivers[v]+'_additional_driver_phoneDirty'] && this.state[drivers[v]+'_additional_driver_phoneError']) &&
													<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_phoneError']}</small>
												}
											</div>
											<div className={'form-group col-md-2 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_dobDirty'] && this.state[drivers[v]+'_additional_driver_dobError']) && ' has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>Date of birth</label>
													<span className="star"> *</span>
												</div>
												<DatePicker
													renderCustomHeader={({
																			 date,
																			 changeYear,
																			 changeMonth,
																			 decreaseMonth,
																			 increaseMonth,
																			 prevMonthButtonDisabled,
																			 nextMonthButtonDisabled,
																		 }) => (
														<div style={{margin: 10, display: "flex", justifyContent: "center"}}>
															<button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{"<"}</button>
															<select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(value)}>
																{birth_years.map((option) => (
																	<option key={option} value={option}>
																		{option}
																	</option>
																))}
															</select>

															<select value={months[(date.getMonth())]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
																{months.map((option) => (
																	<option key={option} value={option}>
																		{option}
																	</option>
																))}
															</select>

															<button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{">"}</button>
														</div>
													)}
													customInput={<CustomInput />}
													onChange={(date) => this.setDate((drivers[v])+'_additional_driver_dob', date)}
													selected={this.state[(drivers[v])+'_additional_driver_dob']}
													dateFormat="dd-MM-yyyy"
													minDate={min_birth_date}
													maxDate={max_birth_date}
													name={(drivers[v])+'_additional_driver_dob'}
													placeholderText={"Date of birth *"}
													startDate={min_birth_date}
													onCalendarOpen={() => {this.setState({[(drivers[v])+'_additional_driver_dobDirty']: true});}}
												/>
												{/*<MaskedInput
													mask={[ /[0-3]/, /\d/,'-', /[0-1]/, /\d/,'-', /\d/, /\d/, /\d/, /\d/]}
													className="form-control datepicker age driver_dob required"
													guide={true}
													name={(drivers[v])+'_additional_driver_dob'}
													pipe={autoCorrectedDatePipe_birth}
													keepCharPositions={true}
													placeholder={"Date of birth *"}
													onChange={this.onChangeInput}
													onBlur={this.onBlurHandler}
												/>*/}
												{
													(this.state[drivers[v]+'_additional_driver_dobDirty'] && this.state[drivers[v]+'_additional_driver_dobError']) &&
													<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_dobError']}</small>
												}
											</div>
										</div>
										<div className="row">
											<div className={'form-group col-md-2 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_licensenoDirty'] && this.state[drivers[v]+'_additional_driver_licensenoError']) && ' has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>License Number</label>
													<span className="star"> *</span>
												</div>
												<input className="form-control required"
													   autoComplete="off" type="text"
													   id={(drivers[v])+'_additional_driver_licenseno'}
													   name={(drivers[v])+'_additional_driver_licenseno'}
													   placeholder={"License Number *"}
													   onChange={this.onChangeInput}
													   onBlur={this.onBlurHandler}
												/>
												{
													(this.state[drivers[v]+'_additional_driver_licensenoDirty'] && this.state[drivers[v]+'_additional_driver_licensenoError']) &&
													<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_licensenoError']}</small>
												}
											</div>
											<div className={'form-group col-md-3 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_license_countryDirty'] && this.state[drivers[v]+'_additional_driver_license_countryError']) && ' has-danger')}>
												<select name={(drivers[v])+'_additional_driver_license_country'} id={(drivers[v])+'_additional_driver_license_country'}
														className="form-control"
														onChange={this.onChange}
														onBlur={this.onBlurHandler}>
													<option value="">Select an Issuing Authority *</option>
													{
														license_country_list.map((val) => <option key={val} value={val}>{val}</option>)
													}
												</select>
												{
													(this.state[drivers[v]+'_additional_driver_license_countryDirty'] && this.state[drivers[v]+'_additional_driver_license_countryError']) &&
													<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_license_countryError']}</small>
												}
											</div>
											<div className={'form-group col-md-2 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_license_expiryDirty'] && this.state[drivers[v]+'_additional_driver_license_expiryError']) && ' has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>License Expiry</label>
													<span className="star"> *</span>
												</div>
												<DatePicker
													renderCustomHeader={({
																			 date,
																			 changeYear,
																			 changeMonth,
																			 decreaseMonth,
																			 increaseMonth,
																			 prevMonthButtonDisabled,
																			 nextMonthButtonDisabled,
																		 }) => (
														<div style={{margin: 10, display: "flex", justifyContent: "center"}}>
															<button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{"<"}</button>
															<select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(value)}>
																{license_years.map((option) => (
																	<option key={option} value={option}>
																		{option}
																	</option>
																))}
															</select>

															<select value={months[(date.getMonth())]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
																{months.map((option) => (
																	<option key={option} value={option}>
																		{option}
																	</option>
																))}
															</select>

															<button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{">"}</button>
														</div>
													)}
													customInput={<CustomInput />}
													onChange={(date) => this.setDate((drivers[v])+'_additional_driver_license_expiry', date)}
													selected={this.state[(drivers[v])+'_additional_driver_license_expiry']}
													dateFormat="dd-MM-yyyy"
													minDate={min_license_expire_date}
													maxDate={max_license_expire_date}
													name={(drivers[v])+'_additional_driver_license_expiry'}
													placeholderText={"License Expiry *"}
													startDate={min_license_expire_date}
													onCalendarOpen={() => {this.setState({[(drivers[v])+'_additional_driver_license_expiryDirty']: true});}}
												/>

												{
													(this.state[drivers[v]+'_additional_driver_license_expiryDirty'] && this.state[drivers[v]+'_additional_driver_license_expiryError']) &&
													<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_license_expiryError']}</small>
												}
											</div>
										</div>

										<div className="row">
											<div className={'form-group col-md-4 fake-placeholder '+((this.state[drivers[v]+'_driver_licenseDirty'] && this.state[drivers[v]+'_driver_licenseError']) && ' has-danger')}>
												<div id={(drivers[v])+'_driver_license_div'} className="tooltip-info-div">
													<UploadPhoto
														photo_key={(drivers[v])+'_driver_license'}
														photo_type={'license'}
														dirty={this.state[drivers[v]+'_driver_licenseDirty']}
														error={this.state[drivers[v]+'_driver_licenseError']}
														handleUploadPhoto={this.handleUploadPhoto}
														reset_photo_fields={this.props.reset_photo_fields}
														handleSetSomeBlock={this.props.handleSetSomeBlock}
													/>
												</div>
												<i className="tooltip-info" data-tip data-for={'react_tooltip_license_'+(drivers[v])}>&nbsp;</i>
												<ReactTooltip
													id={'react_tooltip_license_'+(drivers[v])}
													place="left"
													effect="solid"
													multiline={true}
													className={'react_tooltip'}
													backgroundColor={'black'}
													html={true}
													scrollHide={true}
													isCapture={true}>
													{license_text}
												</ReactTooltip>
											</div>
											{ !this.state[drivers[v]+'_driver_license_eLicense'] &&
												<div className={'form-group col-md-4 fake-placeholder '+((this.state[drivers[v]+'_driver_backDirty'] && this.state[drivers[v]+'_driver_backError']) && ' has-danger')}>
													<div id={(drivers[v])+'_driver_back_div'} className="tooltip-info-div">
														<UploadPhoto
															photo_key={(drivers[v])+'_driver_back'}
															photo_type={'back'}
															dirty={this.state[drivers[v]+'_driver_backDirty']}
															error={this.state[drivers[v]+'_driver_backError']}
															handleUploadPhoto={this.handleUploadPhoto}
															reset_photo_fields={this.props.reset_photo_fields}
															handleSetSomeBlock={this.props.handleSetSomeBlock}
														/>
													</div>
													<i className="tooltip-info" data-tip data-for={'react_tooltip_back_'+(drivers[v])}>&nbsp;</i>
													<ReactTooltip
														id={'react_tooltip_back_'+(drivers[v])}
														place="left"
														effect="solid"
														multiline={true}
														className={'react_tooltip'}
														backgroundColor={'black'}
														html={true}
														scrollHide={true}
														isCapture={true}>
														{back_text}
													</ReactTooltip>
												</div>
											}
											<div className={'form-group col-md-4 fake-placeholder '+((this.state[drivers[v]+'_driver_selfieDirty'] && this.state[drivers[v]+'_driver_selfieError']) && ' has-danger')}>
												<div id={(drivers[v])+'_driver_selfie_div'} className="tooltip-info-div">
													<UploadPhoto
														photo_key={(drivers[v])+'_driver_selfie'}
														photo_type={'selfie'}
														dirty={this.state[drivers[v]+'_driver_selfieDirty']}
														error={this.state[drivers[v]+'_driver_selfieError']}
														handleUploadPhoto={this.handleUploadPhoto}
														reset_photo_fields={this.props.reset_photo_fields}
														handleSetSomeBlock={this.props.handleSetSomeBlock}
													/>
												</div>
												<i className="tooltip-info" data-tip data-for={'react_tooltip_selfie_'+(drivers[v])}>&nbsp;</i>
												<ReactTooltip
													id={'react_tooltip_selfie_'+(drivers[v])}
													place="left"
													effect="solid"
													multiline={true}
													className={'react_tooltip'}
													backgroundColor={'black'}
													html={true}
													scrollHide={true}
													isCapture={true}>
													{selfie_text}
												</ReactTooltip>
											</div>
										</div>
									</div>
									<div className="row">
										<div className={'form-group col-md-4 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_addressDirty'] && this.state[drivers[v]+'_additional_driver_addressError']) && ' has-danger')}>
											<div className="placeholder" style={{display: "none"}}>
												<label>Address</label>
												<span className="star"> *</span>
											</div>
											<input className="form-control required"
												   type="text"
												   id={(drivers[v])+'_additional_driver_address'}
												   name={(drivers[v])+'_additional_driver_address'}
												   placeholder={"Address *"}
												   onChange={this.onChangeInput}
												   onBlur={this.onBlurHandler}
											/>
											{
												(this.state[drivers[v]+'_additional_driver_addressDirty'] && this.state[drivers[v]+'_additional_driver_addressError']) &&
												<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_addressError']}</small>
											}
										</div>
										<div className={'form-group col-md-3 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_cityDirty'] && this.state[drivers[v]+'_additional_driver_cityError']) && ' has-danger')}>
											<div className="placeholder" style={{display: "none"}}>
												<label>City</label>
												<span className="star"> *</span>
											</div>
											<input className="form-control required"
												   type="text"
												   id={(drivers[v])+'_additional_driver_city'}
												   name={(drivers[v])+'_additional_driver_city'}
												   placeholder={"City *"}
												   onChange={this.onChangeInput}
												   onBlur={this.onBlurHandler}
											/>
											{
												(this.state[drivers[v]+'_additional_driver_cityDirty'] && this.state[drivers[v]+'_additional_driver_cityError']) &&
												<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_cityError']}</small>
											}
										</div>
										<div className={'form-group col-md-3 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_stateDirty'] && this.state[drivers[v]+'_additional_driver_stateError']) && ' has-danger')}>
											<div className="placeholder" style={{display: "none"}}>
												<label>State</label>
												<span className="star"> *</span>
											</div>
											{
												(this.state[(drivers[v])+'_additional_driver_license_countryInternational']) ?
													<input className="form-control required"
														   type="text"
														   id={(drivers[v])+'_additional_driver_state'}
														   name={(drivers[v])+'_additional_driver_state'}
														   placeholder={"State *"}
														   onChange={this.onChangeInput}
														   onBlur={this.onBlurHandler}
													/>
													:
													<select name={(drivers[v])+'_additional_driver_state'}
															className="form-control"
															onChange={this.onChangeInput}
															onBlur={this.onBlurHandler}>
														<option value="" >Select a State *</option>
														{
															state_country_list.map((val) => <option key={val} value={val}>{val}</option>)
														}
													</select>
											}
											{
												(this.state[drivers[v]+'_additional_driver_stateDirty'] && this.state[drivers[v]+'_additional_driver_stateError']) &&
												<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_stateError']}</small>
											}
										</div>
										<div className={'form-group col-md-2 fake-placeholder '+((this.state[drivers[v]+'_additional_driver_postcodeDirty'] && this.state[drivers[v]+'_additional_driver_postcodeError']) && ' has-danger')}>
											<div className="placeholder" style={{display: "none"}}>
												<label>Postcode</label>
												<span className="star"> *</span>
											</div>
											<input className="form-control required"
												   id={(drivers[v])+'_additional_driver_postcode'}
												   name={(drivers[v])+'_additional_driver_postcode'}
												   placeholder={"Postcode *"}
												   onChange={this.onChangeInput}
												   onBlur={this.onBlurHandler}
												   value={this.state[(drivers[v])+'_additional_driver_postcode'] || ''}
											/>
											{
												(this.state[drivers[v]+'_additional_driver_postcodeDirty'] && this.state[drivers[v]+'_additional_driver_postcodeError']) &&
												<small className="form-control-feedback d-block">{this.state[drivers[v]+'_additional_driver_postcodeError']}</small>
											}
										</div>
									</div>
								</div>
							)
						})
				}
				<div className="row hire-cost">
					<div className="form-group col">
						<input type="button" className="btn btn-green" value={(this.props.booking_form_data.booking.vehicle_payment === true) ? 'Proceed With Booking' : 'Proceed With Payment'} onClick={this.onClick} />
					</div>
				</div>
			</div>
		</>);
	}
}

export default BookingDetailsPage;
